var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PullTo',{attrs:{"top-load-method":_vm.refresh,"top-config":_vm.CONFIG,"distance-index":3,"is-bottom-bounce":false,"is-touch-sensitive":_vm.isAtTop}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }